import Pricing from "../Components/Pricing/Pricing";

const PricingPage = () => {
  return (
    <div className="w-5/6 mx-auto">
      <Pricing />
    </div>
  );
};

export default PricingPage;
